import { select } from 'async-es';

const getters = {
	refreshKey: state => state.app.refreshKey,
	sidebar: state => state.app.sidebar,
	size: state => state.app.size,
	device: state => state.app.device,
	visitedViews: state => state.tagsView.visitedViews,
	cachedViews: state => state.tagsView.cachedViews,
	token: state => state.user.token,
	avatar: state => state.user.avatar,
	isLoggedIn: state => state.user.isLoggedIn,
	name: state => state.user.name,
	introduction: state => state.user.introduction,
	roles: state => state.user.roles,
	permission_routes: state => state.permission.routes,
	errorLogs: state => state.errorLog.logs,
	// RISOLTO
	cognitoUserData: state => state.risolto.cognitoUserData,
	loggedInUser: state => state.risolto.loggedInUser,
	templateContent: state => state.risolto.templateContent,
	forceSendStore: state => state.risolto.forceSendStore,
	note: state => state.risolto.note,
	selectedInvoices: state => state.risolto.selectedInvoices,
	selectedDocuments: state => state.risolto.selectedDocuments,
	detailViewInvoices: state => state.risolto.detailViewInvoices,
	env: state => state.risolto.env,
	dev: state => state.risolto.dev,
	beta: state => state.risolto.beta,
	legalEntities: state => state.risolto.legalEntities,
	selectedParticipantStore: state => state.risolto.selectedParticipantStore,
	selectedLegalEntityStore: state => state.risolto.selectedLegalEntityStore,
	isDirty: state => state.risolto.isDirty,
	phoneForm: state => state.risolto.phoneForm,
	selectedContact: state => state.risolto.selectedContact,
	selectedChannelEndpoint: state => state.risolto.selectedChannelEndpoint,
	newNoteType: state => state.risolto.newNoteType,
	pdfPreviewDialogVisible: state => state.risolto.pdfPreviewDialogVisible,
	fullscreenLoading: state => state.risolto.fullscreenLoading,
	selectedRecipient: state => state.risolto.selectedRecipient,
	selectedTemplate: state => state.risolto.selectedTemplate,
	PDFPreviewData: state => state.risolto.PDFPreviewData,
	actionDetailDialogVisibleStore: state => state.risolto.actionDetailDialogVisibleStore,
	emailDetailDialogMessage: state => state.risolto.emailDetailDialogMessage,
	emailDetailDialogVisibleStore: state => state.risolto.emailDetailDialogVisibleStore,
	actionPhoneDetailDialogVisibleStore: state => state.risolto.actionPhoneDetailDialogVisibleStore,
	componentTypeStore: state => state.risolto.componentTypeStore,
	actionTableVisibleStore: state => state.risolto.actionTableVisibleStore,
	showActionTableFilters: state => state.risolto.showActionTableFilters,
	actionTableSelectedChannels: state => state.risolto.actionTableSelectedChannels,
	actionTableSelectedStatuses: state => state.risolto.actionTableSelectedStatuses,
	actionPhoneDetailOverlayVisible: state => state.risolto.actionPhoneDetailOverlayVisible,
	actionPhoneDetailOverlayAction: state => state.risolto.actionPhoneDetailOverlayAction,
	participantUsers: state => state.risolto.participantUsers,
	worklistStatusState: state => state.worklist.worklistStatusState,
	worklistDateRange: state => state.worklist.worklistDateRange,
	worklistGroupVars: state => state.worklist.worklistGroupVars,

	// RECIPIENT
	recipientsDetailRightPanelCollapsed: state => state.recipients.detailRightPanelCollapsed,
	recipientsOverviewRightPanelCollapsed: state => state.recipients.overviewRightPanelCollapsed,
	recipientActions: state => state.recipients.recipientActions,
	recipientActionRefs: state => state.recipients.recipientActionRefs,
	recipientStatus: state => state.recipients.recipientStatus,

	// INVOICES
	invoicesRightPanelCollapsed: state => state.invoices.rightPanelCollapsed,
	invoicesOffset: state => state.invoices.offset,
	invoicesLimit: state => state.invoices.limit,
	invoicesPage: state => state.invoices.page,
	invoicesStatus: state => state.invoices.status,
	invoicesDocumentType: state => state.invoices.documentType,
	invoicesDateRange: state => state.invoices.dateRange,
	invoicesSort: state => state.invoices.sort,
	invoicesSearchTerm: state => state.invoices.searchTerm,

	// APOLLO
	risolto_action: state => state.apollo.risolto_action,

	// MESSAGES
	messagesUnreadCount: state => state.messages.unreadCount,
	userInterfaceDetails: state => state.risolto.userInterfaceDetails,

	// ACTIONS
	actionsByReference: state => state.actions.actionsByReference,
	selectedActionRef: state => state.actions.selectedActionRef,
	selectedAction: state => {
		if (!state.actions.selectedActionRef) return null;
		return state.actions.actionsByReference[state.actions.selectedActionRef];
	},
	actionDetailLoading: state => state.actions.detailLoading

};
export default getters;
